import React from 'react';
import { upperFirst, keys, first } from 'lodash';

import Select from './Select';
import AvForm from './AvForm';
import AvGroup from './AvGroup';
import AvInput from './AvInput';
import ButtonArea from './ButtonArea';
import Button from './Button';

export default ({ model, options }) => {
  const urlParams = new URLSearchParams(window.location.search);
  return (
    <AvForm onValidSubmit={model.searchNow}>
      <Select name="field" value={urlParams.get('f') || first(keys(options))}>
        {keys(options).map((option, index) => (
          <option key={index} value={option}>
            {upperFirst(options[option])}
          </option>
        ))}
      </Select>
      <AvGroup>
        <AvInput value={urlParams.get('q') || ''} name="query" />
      </AvGroup>
      <ButtonArea>
        <Button area="button" type="submit" />
      </ButtonArea>
    </AvForm>
  );
};
